import { botResponse$ } from "./chatStream";
import store from "../../../../../app/store";
import moment from "moment";
import {
  addStreamingBotMessage,
  appendStreamingChunk,
  completeStreamingBotMessage,
  setExistingThreadID,
  setExistingThreadName,
  setStreaming,
  setThreadDetails,
} from "../../../../../rtk-query/features/chatbot/chatbotSlice";
import { fetchThreadList } from "../../../../../rtk-query/features/chatbot/chatbotSidebarToolsSlice";

let isSubscribed = false;
let subscription = null;

let currentBotMessageId = null;
let metadata = null;

// ✅ ONLY ONE SOURCE OF TRUTH
let pendingChunk = "";
let flushTimer = null;

function flushChunk() {
  if (!pendingChunk || !currentBotMessageId) return;

  store.dispatch(
    appendStreamingChunk({
      id: currentBotMessageId,
      chunk: pendingChunk,
    }),
  );

  pendingChunk = "";
}

function scheduleChunk(chunk) {
  let cleaned = chunk;

  pendingChunk += cleaned;

  if (pendingChunk.length > 300) {
    flushChunk();
    return;
  }

  if (flushTimer) return;

  flushTimer = setTimeout(() => {
    flushChunk();
    flushTimer = null;
  }, 1500);
}

function parseChunk(rawData) {
  const lines = rawData.split("\n");

  let result = "";

  for (const line of lines) {
    const trimmed = line.trimStart();
    if (line.startsWith("data: ")) {
      result += line.replace(/^data:\s?/, "");
    } else if (trimmed === "---") {
      // Horizontal rule
      result += "\n\n---\n\n";
    } else if (trimmed === "```") {
      result += "\n```\n";
    } else if (result.endsWith("**") && /^[0-9]/.test(trimmed)) {
      result += "\n\n" + line;
    }
    // Normal data content
    else if (
      !line.startsWith("data:") &&
      (trimmed.startsWith("**") || trimmed.startsWith("#"))
    ) {
      result += "\n\n" + trimmed;
    } else if (!line.startsWith("data:") && /^[A-Z]/.test(trimmed)) {
      result += "\n\n" + trimmed;
    } else if (line.startsWith("#")) {
      result += "\n" + trimmed + "\n\n";
    } else if (
      line.startsWith("- ") ||
      line.startsWith("* ") ||
      line.startsWith("|") ||
      line.startsWith("```") ||
      line.startsWith("✓") ||
      /^\d+\.\s/.test(trimmed) || // 1. Item
      /^\d+$/.test(trimmed)
    ) {
      result += "\n" + line;
    } else {
      result += line;
    }
  }

  return result;
}

export const initChatStreamListener = () => {
  if (isSubscribed) return;

  isSubscribed = true;

  subscription = botResponse$.subscribe((event) => {
    const rawData = event?.data;
    if (!rawData) return;

    let value = parseChunk(rawData);

    const trimmedValue = value.trim();
    if (!trimmedValue) return;

    if (trimmedValue === "[DONE]") {
      flushChunk();

      if (flushTimer) {
        clearTimeout(flushTimer);
        flushTimer = null;
      }

      store.dispatch(
        completeStreamingBotMessage({
          id: currentBotMessageId,
          feedbackId: metadata?.Id,
          isLike: metadata?.isLike,
        }),
      );

      if (metadata) {
        store.dispatch(
          setThreadDetails({
            threadId: metadata.ThreadId,
            threadName: metadata.ThreadName,
          }),
        );

        store.dispatch(fetchThreadList());
      }

      store.dispatch(setExistingThreadID(metadata.ThreadId));
      store.dispatch(setExistingThreadName(metadata.ThreadName));

      store.dispatch(setStreaming(false));

      currentBotMessageId = null;
      metadata = null;
      pendingChunk = "";

      return;
    }

    if (trimmedValue.startsWith("{")) {
      try {
        metadata = JSON.parse(trimmedValue);
      } catch (e) {
        store.dispatch(setStreaming(false));
        console.error("Metadata parse error", e);
      }
      return;
    }

    if (!currentBotMessageId) {
      currentBotMessageId = Date.now();

      store.dispatch(
        addStreamingBotMessage({
          id: currentBotMessageId,
          dateTime: moment(),
        }),
      );
    }

    scheduleChunk(value);
  });
};

export const destroyChatStreamListener = () => {
  if (flushTimer) {
    clearTimeout(flushTimer);
    flushTimer = null;
  }

  pendingChunk = "";

  if (subscription) {
    subscription.unsubscribe();
    subscription = null;
  }

  isSubscribed = false;
};
